var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('search-product'),_c('b-row',[_c('b-col',{attrs:{"cols":"12","md":"6"}},[_c('brands')],1),_c('b-col',{attrs:{"cols":"12","md":"6"}},[_c('categories')],1)],1),_c('list-product')],1)}
var staticRenderFns = []

export { render, staticRenderFns }